import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { LiveCallState } from 'store/types'
import { useAppSelector, useAppDispatch, LiveCall as LiveCallActions } from 'store'
import { getLiveCall, getLiveCallStatus } from 'services/liveCall'
import { getLeadRoute } from 'utils/url'

const useLiveCall: () => { liveCallState: LiveCallState; goToActivity: () => void; getStatus: () => void } = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const liveCallState = useAppSelector((state) => state.liveCall)
  const { leadId } = liveCallState

  const fetchLiveCall = useCallback(async () => {
    if (!liveCallState.liveCall?.live_call_id) return

    const response = await getLiveCall(liveCallState.liveCall?.live_call_id)
    if (response.status === 'SUCCESS') {
      const { data } = response.data
      dispatch(
        LiveCallActions.setLiveCall({
          liveCall: {
            live_call_id: data.live_call_id,
            lead_activity_id: data.lead_activity_id,
            start_time: data.start_time,
            end_time: data.end_time,
            create_ts: data.create_ts,
            update_ts: data.update_ts,
            duration: data.duration,
          },
        }),
      )
      return data
    }
  }, [dispatch, liveCallState.liveCall])

  const goToActivity = useCallback(async () => {
    if (leadId) {
      navigate(`${getLeadRoute({ leadId })}?window=activities-tab`)
      return
    }
  }, [navigate, leadId])

  const getStatus = useCallback(() => dispatch(getLiveCallStatus()), [dispatch])

  return { liveCallState, goToActivity, getStatus }
}

export default useLiveCall
